<div
	class="p-8 flex flex-col w-full h-full bg-grey-lightest"
	*ngIf="vm$ | async as vm"
>
	<div class="flex justify-between">
		<div class="flex gap-2">
			<h1 class="h1">Charge</h1>
			<app-anchor
				[url]="teraviewLink"
				[cssClasses]="['!no-underline']"
				[external]="true"
			>
				<ui-button
					data-intercom-target="launch-teraview-button"
					class="!no-underline"
					icon="rocket"
					[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
					label="Launch Teraview"
				></ui-button>
			</app-anchor>
		</div>

		<div>
			<app-mortgage-selector-tabs
				[url]="baseUrl"
				[hideBridge]="true"
				data-intercom-target="charges-mortgage-selector-tabs"
			/>
		</div>
	</div>
	<div *ngIf="!mortgages?.length" class="flex flex-col gap-6 items-center">
		<img
			src="/assets/images/undraw/undraw_void_3A335B.svg"
			class="max-w-80 max-h-80"
		/>
		<h2 class="h2">Nothing to See Here</h2>
		<p class="p">
			Please add a mortgage to your matter to create the Charge XML
		</p>
		<ui-button
			icon="plus"
			label="Add a mortgage"
			(click)="goToMortgages()"
		></ui-button>
	</div>
	<router-outlet></router-outlet>
</div>
